module.exports = __webpack_public_path__ + "img/5New.bdd100d2.png";